module.exports = __webpack_public_path__ + "static/media/ils_esign_kyc.b8159ad4.svg";